import React from 'react';

const Benefits = () => {
  const benefits = [
    {
      icon: (
        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
      ),
      title: 'Ahorra 3-5 horas cada semana',
      description: 'Dedica más tiempo a enseñar y menos a preparar. Tareia hace el trabajo pesado por ti.',
      stat: '3-5h ahorradas/semana',
      color: 'primary'
    },
    {
      icon: (
        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
        </svg>
      ),
      title: 'Actividades únicas en 15 segundos',
      description: 'Cada actividad es generada específicamente para tu tema y nivel. Nunca más actividades repetidas.',
      stat: 'Generación en 15s',
      color: 'accent'
    },
    {
      icon: (
        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 4a2 2 0 114 0v1a1 1 0 001 1h3a1 1 0 011 1v3a1 1 0 01-1 1h-1a2 2 0 100 4h1a1 1 0 011 1v3a1 1 0 01-1 1h-3a1 1 0 01-1-1v-1a2 2 0 10-4 0v1a1 1 0 01-1 1H7a1 1 0 01-1-1v-3a1 1 0 00-1-1H4a1 1 0 01-1-1V9a1 1 0 011-1h1a2 2 0 100-4H4a1 1 0 01-1-1V4a1 1 0 011-1h3a1 1 0 011 1v1z" />
        </svg>
      ),
      title: 'Adaptado a tu contexto educativo',
      description: 'Actividades diseñadas para el contexto latinoamericano, con ejemplos y situaciones familiares para tus estudiantes.',
      stat: 'Contexto latinoamericano',
      color: 'secondary'
    },
    {
      icon: (
        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
        </svg>
      ),
      title: 'Material educativo listo para usar',
      description: 'Actividades estructuradas y profesionales que puedes imprimir y usar inmediatamente en tu salón de clases',
      stat: 'Formato PDF',
      color: 'purple'
    }
  ];
  
  const colorClasses = {
    primary: {
      bg: 'bg-primary-50',
      border: 'border-primary-200',
      icon: 'text-primary-600',
      stat: 'text-primary-600 bg-primary-100'
    },
    accent: {
      bg: 'bg-orange-50',
      border: 'border-orange-200',
      icon: 'text-orange-600',
      stat: 'text-orange-600 bg-orange-100'
    },
    secondary: {
      bg: 'bg-secondary-50',
      border: 'border-secondary-200',
      icon: 'text-secondary-600',
      stat: 'text-secondary-600 bg-secondary-100'
    },
    purple: {
      bg: 'bg-purple-50',
      border: 'border-purple-200',
      icon: 'text-purple-600',
      stat: 'text-purple-600 bg-purple-100'
    }
  };
  
  return (
    <section id="beneficios" className="bg-white section-padding">
      <div className="container-max px-6 sm:px-8 lg:px-12">
        <div className="max-w-4xl mx-auto text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-8">
            ¿Por qué los docentes eligen Tareia?
          </h2>
          <p className="text-lg sm:text-xl text-gray-600">
            Descubre cómo Tareia puede transformar tu forma de preparar clases y 
            darte más tiempo para lo que realmente importa: enseñar.
          </p>
        </div>
        
        <div className="grid md:grid-cols-2 gap-6 sm:gap-8 mb-16">
          {benefits.map((benefit, index) => {
            const colors = colorClasses[benefit.color];
            return (
              <div key={index} className={`${colors.bg} ${colors.border} border-2 rounded-2xl p-6 sm:p-8 h-full`}>
                <div className={`w-16 h-16 ${colors.icon} ${colors.bg} rounded-2xl flex items-center justify-center mb-6`}>
                  {benefit.icon}
                </div>
                
                <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-4">
                  {benefit.title}
                </h3>
                
                <p className="text-gray-600 mb-6 leading-relaxed">
                  {benefit.description}
                </p>
                
                <div className={`inline-block ${colors.stat} px-4 py-2 rounded-full text-sm font-semibold`}>
                  {benefit.stat}
                </div>
              </div>
            );
          })}
        </div>
        
        {/* Testimonial Section */}
        <div className="bg-gradient-to-r from-gray-50 to-primary-50 rounded-2xl p-6 sm:p-8 md:p-12">
          <div className="max-w-3xl mx-auto text-center">
            <div className="w-16 h-16 bg-primary-600 rounded-full flex items-center justify-center mx-auto mb-6">
              <svg className="w-8 h-8 text-white" fill="currentColor" viewBox="0 0 24 24">
                <path d="M14.017 21v-7.391c0-5.704 3.731-9.57 8.983-10.609l.995 2.151c-2.432.917-3.995 3.638-3.995 5.849h4v10h-9.983zm-14.017 0v-7.391c0-5.704 3.748-9.57 9-10.609l.996 2.151c-2.433.917-3.996 3.638-3.996 5.849h4v10h-10z"/>
              </svg>
            </div>
            
            <blockquote className="text-lg sm:text-xl md:text-2xl text-gray-700 font-medium mb-6 leading-relaxed">
              "Preparar actividades me toma horas. Esto me ahorraría muchísimo tiempo."
            </blockquote>
            
            <div className="flex items-center justify-center">
              <div className="text-left">
                <p className="font-semibold text-gray-900">— Docente de primaria</p>
              </div>
            </div>
          </div>
        </div>
        
        {/* Stats Section */}
        <div className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-6 sm:gap-8 text-center">
          <div>
            <div className="text-2xl sm:text-3xl md:text-4xl font-bold text-primary-600 mb-2">3-5h</div>
            <div className="text-sm sm:text-base text-gray-600">Tiempo actual preparando</div>
          </div>
          <div>
            <div className="text-2xl sm:text-3xl md:text-4xl font-bold text-orange-600 mb-2">15s</div>
            <div className="text-sm sm:text-base text-gray-600">Tiempo con Tareia</div>
          </div>
          <div>
            <div className="text-2xl sm:text-3xl md:text-4xl font-bold text-secondary-600 mb-2">15+</div>
            <div className="text-sm sm:text-base text-gray-600">Tipos de actividades</div>
          </div>
          <div>
            <div className="text-2xl sm:text-3xl md:text-4xl font-bold text-purple-600 mb-2">100%</div>
            <div className="text-sm sm:text-base text-gray-600">Adaptado a tu nivel</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Benefits;